import React, { useState, useEffect } from "react";
import EditableFeedbackForm from "./component/EditableFeedbackForm";
import SubmittedFeedbackView from "./component/SubmittedFeedbackView";

export const Feedback = ({ candidateId, applicationId, data, currentStatus, jobId }) => {
  const [submittedFeedback, setSubmittedFeedback] = useState(data);

  useEffect(() => {
    setSubmittedFeedback(data);
  }, [data]);

  const hasReviews = Object.values(submittedFeedback?.category_reviews || {}).some(
    (review) => review?.trim()
  );

  const isSubmitted =
    submittedFeedback &&
    submittedFeedback.feedback_score !== undefined &&
    submittedFeedback.feedback_score !== null &&
    hasReviews;

  return (
    <div className="h-full overflow-y-auto custom-scrollbar px-4 py-4">
      {isSubmitted ? (
        <SubmittedFeedbackView data={submittedFeedback} />
      ) : (
        <EditableFeedbackForm
          candidateId={candidateId}
          applicationId={applicationId}
          jobId={jobId}
          currentStatus={currentStatus}
          onSuccess={setSubmittedFeedback}
        />
      )}
    </div>
  );
};

export default Feedback;